import { Base64 } from 'js-base64';
import * as classNames from 'classnames';
import { ContextService } from '../../../services/context_service';
import { DataService } from '../../../services/data_service';
import formStyle from '../style/WForm.less';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { resizeImage } from '../helpers/resizeImage';
import { WArchivIcon } from '../../../core/elements/WArchivIcon';
import { DateiablageGalerie } from '../../../bereiche/dateiablage/DateiablageGalerie';
import { IDs } from '../../../helpers/IDs';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';

interface WFormFieldArchivProps extends React.ClassAttributes<any> {
    entity?: string;
    label: JSX.Element;
    name: string;
    value: string;
    data: any;  // Ganzer Datensatz
    required?: boolean;
    readonly?: boolean;
    showMode?: boolean;
    hidden_input?: boolean;
    hidden_msg?: string;
    format?: string;
    layout?: string;
    layout2?: string;
    disabled?: boolean;
    module?: string;
    globalData?: any;
    onValueChange?(name: string, value: any): void;
    onGalleryChange?: (action: string, row: any) => void;
}

interface WFormFieldArchivState extends React.ClassAttributes<any> {
    data: any;
    activeClass?: string;
    bgBild?: string;
    file: any;
    is_img: boolean;
}

export class WFormFieldArchiv extends React.Component<WFormFieldArchivProps, WFormFieldArchivState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: this.props.data,
            bgBild: this.props.layout === 'flowV2' ? 'bgBild' : '',
            file: null,
            is_img: false
        };
        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.onDeleteFile = this.onDeleteFile.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService; // Nur zur Abfrage des Limits

    private resizeWidth = 1280;
    private resizeHeight = 1024;

    componentDidMount() {
        this.setResizeDefault();
    }

    // componentDidUpdate(prevProps: any, prevState: any) {
    //     console.log(prevProps.data[prevProps.name], this.props.data[this.props.name]);
    // }

    getFileIcon(filename: string) {
        if (!filename) {
            return null;
        }
        return require('../../../icons/theme/icon_file.svg');

        // const flow = filename.toLocaleLowerCase();
        // if (flow.endsWith('.png') || flow.endsWith('.jpg') || flow.endsWith('.jpeg') || flow.endsWith('.gif')) {
        //     return require('../../../icons/icons8-full-image-64.png');
        // }
        // if (flow.endsWith('.xls') || flow.endsWith('.xlsx')) {
        //     return require('../../../icons/icons8-excel50.png');
        // }
        // if (flow.endsWith('.doc') || flow.endsWith('.docx') || flow.endsWith('.rtf')) {
        //     return require('../../../icons/icons8-word50.png');
        // }
        // if (flow.endsWith('.pdf')) {
        //     return require('../../../icons/theme/icon_file.svg');
        // }
        // if (flow.endsWith('.zip')) {
        //     return require('../../../icons/icons8-zip.svg');
        // }
        // if (flow.endsWith('.csv')) {
        //     return require('../../../icons/theme/icon_file.svg');
        // }
        // if (flow.endsWith('.txt')) {
        //     return require('../../../icons/theme/icon_file.svg');
        // }
        // return require('../../../icons/theme/icon_file.svg');
    }

    getInputId() {
        let id = this.props.entity ? this.props.entity : '';
        id += '_' + this.props.name;
        id += '_' + new Date().getTime();
        id += '_' + Math.floor(Math.random() * (999999 - 0));
        return id;
    }

    handleChangeFile(file: any) {
        if (this.dataService.fileSizeCheck && file.size >= this.dataService.fileSizeLimit) {
            alert('Bitte verwenden Sie nur Bilder mit einer maximalen Größe von ' + this.dataService.fileSizeInfo);
        } else {
            this.setState({ file });
            const reader = new FileReader();
            const that = this;
            reader.onload = function (event: any) {
                // that.props.onDataLoaded(event.target.result);
                const data = event.target.result;
                const b64 = Base64.btoa(data);
                that.props.onValueChange(that.props.name + '_archiv_delete', 0); // Marke -> Löschen NICHT!
                that.props.onValueChange(that.props.name + '_archiv_rawdata', b64);
                that.props.onValueChange(that.props.name + '_archiv_filename', file.name);
                that.props.onValueChange(that.props.name, 0);

                // Prüf Bilder
                that.setState({ is_img: false }, () => {
                    const image = new Image();
                    image.onload = () => {
                        if (image.width) {
                            // Datei ist Bilder
                            that.setState({ is_img: true });
                            // Resize
                            resizeImage('data:image/png;base64,' + b64, (rB64: string) => {
                                rB64 = rB64.substring(rB64.indexOf(',') + 1);
                                that.props.onValueChange(that.props.name + '_archiv_rawdata', rB64);
                            }, that.resizeWidth, that.resizeHeight);
                        }
                    };
                    image.src = URL.createObjectURL(file);
                });
            };

            if (typeof reader.readAsBinaryString === 'function') {
                reader.readAsBinaryString(file);
            } else {
                // IE11 Lösung
                const blobURL = URL.createObjectURL(file);
                const xhr = new XMLHttpRequest;
                xhr.open('get', blobURL);
                xhr.overrideMimeType('text/plain; charset=x-user-defined');
                xhr.onload = function () {
                    const binary = xhr.response;
                    const b64 = Base64.btoa(binary);
                    that.props.onValueChange(that.props.name + '_archiv_rawdata', b64);
                    that.props.onValueChange(that.props.name + '_archiv_filename', file.name);
                    that.props.onValueChange(that.props.name, 0);
                };
                xhr.send();
            }
        }
    }

    onDeleteFile() {
        if (!window.confirm('Datei löschen?')) {
            return;
        }
        const { data } = this.state;
        const fieldName: string = this.props.name;
        data[fieldName] = null;
        this.setState({ data, file: null }, () => {
            // Marke -> Löschen
            this.props.onValueChange(fieldName + '_archiv_delete', 1);
        });
    }

    render() {
        if (this.props.format && this.props.format === 'GALLERY') {
            if (!this.props.data || !this.props.data.tid) {
                return <div className={formStyle.fieldBox}>
                    {this.props.label}
                    <div className={classNames(formStyle.input, this.props.showMode ? formStyle.showMode : null)}></div>
                </div>;
            } else {
                const key = this.props.entity + '_' + this.props.data.tid;
                // this.saveGalleryItem(key); // Deaktiviert wegen WKETOOL-93 446: Mehrfache Rechnungs-Dateien
                return <div className={formStyle.fieldBox} style={{ paddingLeft: 0, boxSizing: 'border-box' }}>
                    {this.props.label}
                    <div className={classNames(formStyle.input, this.props.showMode ? formStyle.showMode : null)} style={{ display: 'flex' }}>
                        {this.props.hidden_input ?
                            this.props.hidden_msg ? <i style={{ paddingTop: 5, color: '#666' }}>&nbsp;{this.props.hidden_msg}</i> : null :
                            <DateiablageGalerie
                                data={this.props.data}
                                id={key}
                                showTable={true}
                                name={'Dokumente'}
                                modeIcon={true}
                                showMode={this.props.showMode}
                                onChange={this.props.onGalleryChange}
                            />
                        }
                    </div>
                </div>;
            }
        }

        const krCls = getKomplexRowClassname((this.props.data || {})._formKey, this.props.name) || undefined;

        if (this.props.showMode) {
            return <div className={classNames(formStyle.fieldBox, krCls)}>
                {this.props.label}
                <div className={classNames(formStyle.input, formStyle.showMode)}></div>
            </div>;
        }

        const { layout, layout2 } = this.props;
        const { data } = this.state;
        const disabled = this.props.readonly || this.props.disabled ? true : false;

        // const complexLayout =layout === 'sidebysideComplex' ? true : false;
        const complexLayout = true;
        const flowV2Layout = layout === 'flowV2' ? true : false;
        const noneAutoSaveLayout = layout === 'noneAutoSave' || layout2 === 'noneAutoSave' ? true : false;

        const inputWrapper: any = complexLayout ? { alignItems: 'center', width: 'auto' } : { marginBottom: 10 };
        const inputId = this.getInputId();
        const flexWrapper: any = complexLayout
            ? { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }
            : { flexDirection: 'column' };

        return (
            <div className={classNames(formStyle.fieldBox, krCls)}>
                {this.props.label}
                <div className={formStyle.input} style={{ display: 'flex', ...flexWrapper }}>
                    <div style={{ display: 'flex', ...inputWrapper }}>
                        {complexLayout &&
                            <button style={{
                                padding: 3, width: 120, height: 23,
                                ...(flowV2Layout ? { height: 28 } : {}),
                                ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {})
                            }}>
                                <label htmlFor={'fileUploader' + inputId} style={{
                                    cursor: 'pointer',
                                    ...(disabled ? { cursor: 'not-allowed' } : {})
                                }}>
                                    Datei wählen
                                </label>
                            </button>
                        }
                        <input
                            style={{
                                display: 'none',
                                border: 'unset !important',
                                ...(complexLayout ? { width: 0, height: 0 } : {})
                            }}
                            type='file'
                            onChange={e => this.handleChangeFile(e.target.files[0])}
                            id={'fileUploader' + inputId}
                            disabled={disabled}
                        />
                    </div>
                    {data[this.props.name] > 0 ?
                        <div
                            style={{
                                display: 'flex', flexDirection: 'row',
                                ...(complexLayout ? { marginRight: 20, marginLeft: 10 } : { alignItems: 'flex-start', justifyContent: 'space-between' })
                            }}
                        >
                            <div
                                className={complexLayout ? formStyle.hasArchiv : undefined}
                                style={{
                                    ...(flowV2Layout ? { height: 'auto', paddingTop: 3 } : {})
                                }}
                            >
                                <WArchivIcon
                                    archivId={data[this.props.name]}
                                    iconSize={flowV2Layout ? 28 : complexLayout ? 20 : null}
                                    previewSize={flowV2Layout ? 28 : complexLayout ? 20 : null}
                                    fixedHight={complexLayout ? true : null}
                                    hideFilename={complexLayout ? true : null}
                                    module={this.props.module}
                                    name={this.props.name}
                                    onValueChange={this.props.onValueChange}
                                    useStandardIcon={true}
                                />
                            </div>
                            {this.renderDelete()}
                        </div>
                        :
                        this.state.file && (noneAutoSaveLayout ?
                            <div style={{ display: 'flex', flexDirection: 'row', marginRight: 20, marginLeft: 10, alignItems: 'baseline' }}>
                                <div
                                    className={complexLayout ? formStyle.hasArchiv : undefined}
                                    style={{
                                        ...(flowV2Layout ? { height: 35 } : {})
                                    }}
                                >
                                    <img
                                        alt='pdf'
                                        src={this.getFileIcon('.pdf')}
                                        style={{
                                            width: 20, height: 20, marginTop: 0,
                                            ...(flowV2Layout ? { width: 28, height: 35 } : {})
                                        }}
                                    />
                                </div>
                                {this.renderDelete()}
                            </div>
                            :
                            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Lade ...</div>
                        )
                    }
                </div>
            </div>
        );
    }

    renderDelete() {
        const flowV2Layout = this.props.layout === 'flowV2' ? true : false;
        return <button
            style={{
                ...(flowV2Layout ? { width: 28, height: 28, backgroundSize: 28 } : {})
            }}
            className={formStyle.fileDelete}
            onClick={this.onDeleteFile}
            title='Datei löschen'
        />;
    }

    setResizeDefault() {
        const size: number = (((this.contextService.get('systemparameter') || [])
            .find((item: any) => item.parameter === 'max_bildgroesse')) || {}).wert || null;

        if (+size > 0) {
            this.resizeWidth = +size;
            this.resizeHeight = +size;
        }
    }

    saveGalleryItem(key: string) {
        const arcTid = this.props.data[this.props.name];
        if (arcTid > 0 && !this.props.data[this.props.name + '_archiv_delete']) {
            // Es existiert noch eine Datei im "alten" Feld
            this.dataService.loadData(IDs.ENT_ARCHIV_ITEMS, { tid: arcTid }, { fieldList: 'file' }, (res: any) => {
                const rows = res[IDs.ENT_ARCHIV_ITEMS];
                if (rows.length > 0) {
                    let filename = rows[0].file;
                    filename = filename.substring(filename.lastIndexOf('/') + 1);
                    filename = filename.substring(filename.indexOf('_') + 1);
                    // console.log(filename);
                    // Überprüfen, ob die Datei vorhanden ist.
                    this.dataService.loadData(IDs.ENT_GALLERY, { name: filename, foto: arcTid, parent_entity: key }, { fieldList: 'tid' }, (res2: any) => {
                        const rows2 = res2[IDs.ENT_GALLERY];
                        if (Array.isArray(rows2) && rows2.length === 0) {
                            const saveItem = {
                                tid: 0,
                                name: filename,
                                foto: arcTid + '',
                                parent_tid: '9999',
                                parent_key: '',
                                parent_entity: key
                            };
                            this.dataService.saveData(IDs.ENT_GALLERY, saveItem, null, null, (suc: boolean) => {
                                // alert('Gespeichert!');
                                this.props.onValueChange(this.props.name + '_archiv_delete', 1);
                            }, IDs.MOD_ETOOL);
                        } else {
                            console.log('Doppelte Datensätze in ENT_GALLERY gefunden!', rows2);
                        }
                    }, IDs.MOD_ETOOL);
                }
            }, IDs.MOD_ETOOL);
        }
    }
}
